import { createElement, type CSSProperties } from "react";

import { Image, Platform } from "react-native";

import { styles } from "../AppShell.styles.js";
import { patientMobilePalette } from "../shell-core.js";
import { resolvePatientBrand } from "./brand.js";

const brand = resolvePatientBrand();

export const legacyWebShellAssets = {
  clinicianAvatarIdleVideoUri:
    "https://d12niuevuci1sc.cloudfront.net/avatar_idle_alice.mp4",
  clinicianAvatarUri: "/avatar_michelle.png",
  clinicianBackgroundUri: "/clinician_background.jpeg",
  hospitalLogoUri: "/merritt_healthcare_logo.png",
} as const;

export const legacyBackgroundTextureSource = {
  uri: legacyWebShellAssets.clinicianBackgroundUri,
} as const;

const patientDesktopAgentAvatarVideoStyle: CSSProperties = {
  backgroundColor: patientMobilePalette.white,
  borderRadius: 8,
  display: "block",
  height: "100%",
  objectFit: "cover",
  width: "100%",
};

const patientDesktopAgentIdentityAvatarVideoStyle: CSSProperties = {
  borderRadius: 32,
  display: "block",
  height: 64,
  objectFit: "cover",
  width: 64,
};

const patientMobileChatAvatarVideoStyle: CSSProperties = {
  borderRadius: 21,
  display: "block",
  height: 42,
  objectFit: "cover",
  width: 42,
};

function renderPatientAgentIdleVideo(
  labelText: string,
  style: CSSProperties,
) {
  return createElement("video", {
    "aria-label": labelText,
    autoPlay: true,
    loop: true,
    muted: true,
    playsInline: true,
    preload: "auto",
    src: legacyWebShellAssets.clinicianAvatarIdleVideoUri,
    style,
  });
}

export function renderPatientDesktopAgentAvatarMedia() {
  if (Platform.OS !== "web") {
    return (
      <Image
        accessibilityLabel={brand.assistantName}
        resizeMode="contain"
        source={{ uri: legacyWebShellAssets.clinicianAvatarUri }}
        style={styles.patientDesktopAgentHeroImage}
      />
    );
  }

  return renderPatientAgentIdleVideo(
    `Animated ${brand.assistantName}`,
    patientDesktopAgentAvatarVideoStyle,
  );
}

export function renderPatientDesktopAgentIdentityAvatarMedia() {
  if (Platform.OS !== "web") {
    return (
      <Image
        accessibilityLabel={brand.assistantName}
        resizeMode="cover"
        source={{ uri: legacyWebShellAssets.clinicianAvatarUri }}
        style={[
          styles.patientDesktopAgentAvatarImage,
          {
            borderRadius: 32,
            height: 64,
            width: 64,
          },
        ]}
      />
    );
  }

  return renderPatientAgentIdleVideo(
    `Animated ${brand.assistantName}`,
    patientDesktopAgentIdentityAvatarVideoStyle,
  );
}

export function renderPatientMobileChatAvatarMedia() {
  if (Platform.OS !== "web") {
    return (
      <Image
        accessibilityLabel={brand.assistantName}
        resizeMode="cover"
        source={{ uri: legacyWebShellAssets.clinicianAvatarUri }}
        style={styles.patientMobileChatAvatar}
      />
    );
  }

  return renderPatientAgentIdleVideo(
    `Animated ${brand.assistantName}`,
    patientMobileChatAvatarVideoStyle,
  );
}
